export default __webpack_public_path__ + "static/media/axelar.3074bfcb.svg";